@let items = (facilities$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.facility"
  chosenTranslationKey="monitoring.facilities-chosen"
  [options]="items"
  [formControl]="controlEntity"
  (shouldLoadMoreOptions)="loadMore()"
/>
